<template>
  <a-layout style="height:100%">
    <a-layout-header>
      <a-row  style="color: #FFF;display:flex;flex-direction:row;justify-content:space-between;">
        <div style="color: #FFF; font-size: 20px;font-weight: bold; ">炫图 AI</div>
        <div>
          <span style="font-size: 14px;">当前用户: {{nickname}} ({{ department }})</span>
          <a-button type="link" @click="handleLogout">退出</a-button>
        </div>
      </a-row>
    </a-layout-header>

    <a-layout >
      <a-layout-sider collapsible v-if="!isMobileView" >
          <Navi />
      </a-layout-sider>
      <a-layout-content >
          <Navi v-if="isMobileView" />
          <a-layout-content class="main-container" style="min-height: 200px; overflow: scroll;">
            <router-view />
            <a-layout-footer>
              <div style="text-align: center;">
                2025©copyright Xuantu
              </div>
            </a-layout-footer>
          </a-layout-content>
      </a-layout-content>
    </a-layout>

  </a-layout>
</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import Navi from '../components/Navi.vue';
import store from '@/store'
import {reactive} from 'vue'
import request from '../utils/request'
import {UserRoleMap} from '@/utils/macro.js'
@Options({
  components: {
      Navi
  },
  props: {
    msg: String
  },
  data(){
     return reactive({
      user_id: store.state.user.user_id,
    })
  },
  computed:{
    isMobileView: () => {
      return window.innerWidth < 768
    },
    department: () => {
      return store.state.user.department
    },
    nickname: () => {
      return store.state.user.nickname
    }
  },
  methods: {
    handleLogout(){
        request.get(`/api/account/logout`).then(() => {
          location.href="/"
        })
      }
  },
  setup(){
   
    return {
      UserRoleMap
    }
  }
})

export default class BasicLayout extends Vue {
  msg!: string
}
</script>

<style >

</style>